import { AdminInvitationsTable } from "./admin-invitations-table"

export function AdminInviteLinksScreen() {
  return (
    <AdminInvitationsTable
      title="Invite Links"
      description="View and manage all invitation links in the system."
    />
  )
}
